import React from 'react'
import { BtnV2, l } from '@manychat/manyui'

import cm from './styles.module.css'

export const EmptyState = ({ onStart }: { onStart: () => void }) => {
  return (
    <div className={cm.wrapper}>
      <h2 className="text-subheading text-center">{l.translate('Preview AI’s follow-up')}</h2>
      <p className="m-t-xxs text-center">
        {l.translate('See how AI collects information and shows the results here.')}
      </p>
      <BtnV2 onClick={onStart} className="m-t" label={l.translate('Try the preview')} />
    </div>
  )
}
